import React, { useState } from "react";
// import "../../style/pages/categoriespage/pistols.css";
import { useNavigate } from "react-router-dom"
import Header from "../../component/Header.jsx";
import Filter from "../../component/Filter.jsx";
import ItemGrid from "../../component/ItemGrid.jsx";

import p1 from "../../media3/categories/p1.png";
import p2 from "../../media3/categories/p2.png";
import p3 from "../../media3/categories/p3.png";
import p4 from "../../media3/categories/p4.png";
import p5 from "../../media3/categories/p5.png";
import p6 from "../../media3/categories/p6.png";
import p7 from "../../media3/categories/p7.png";
import p8 from "../../media3/categories/p8.png";
import p9 from "../../media3/categories/p9.png";
import p10 from "../../media3/categories/p10.png";
import p11 from "../../media3/categories/p11.png";
import p12 from "../../media3/categories/p12.png";
import p13 from "../../media3/categories/p13.png";
import p14 from "../../media3/categories/p14.png";
import p15 from "../../media3/categories/p15.png";
import p16 from "../../media3/categories/p16.png";
import p17 from "../../media3/categories/p17.png";
import p18 from "../../media3/categories/p18.png";
import p19 from "../../media3/categories/p19.png";
import p20 from "../../media3/categories/p20.png";
import p21 from "../../media3/categories/p21.png";
import p22 from "../../media3/categories/p22.png";
import p23 from "../../media3/categories/p23.png";
import p24 from "../../media3/categories/p24.png";
import p from "../../media3/categories/ap.png";


// Dummy data


export const pistolsData = [
  {
    id: 1,
    name: "V75-Auto | Slalom",
    img: p4,
    price: 61,
    maxPrice: 122,
    color: "white",
    rating: 4,
    rarity: "Restricted",
    orderedBy: "Popularity",
    currency: "USD",
    description: "Pink and blue ski-themed paint job applied to the V75-Auto. Perfect for slaloming through enemy fire with style and precision.",
    stats: {
      damage: 8,
      accuracy: 65,
      rateOfFire: 90,
      control: 55,
      range: 35,
      magazineCapacity: 12
    },
  },
  {
    id: 2,
    name: "Desert Eagle | Blaze",
    img: p2,
    price: 80,
    maxPrice: 120,
    color: "purple",
    rating: 5,
    rarity: "Covert",
    orderedBy: "Price",
    currency: "USD",
    description: "It has been painted with a chrome base coat and candied in transparent flame-colored paints. The flame pattern is semi-transparent, allowing the chrome underneath to shine through in a blazing inferno.",
        stats: {
      damage: 18,
      accuracy: 65,
      rateOfFire: 90,
      control: 55,
      range: 35,
      magazineCapacity: 12
    },
  },
  {
    id: 3,
    name: "Glock-18 | Fade",
    img: p3,
    price: 95,
    maxPrice: 160,
    color: "green",
    rating: 4,
    rarity: "Classified",
    orderedBy: "Rating",
    currency: "USD",
    description: "The body of the Glock-18 has been airbrushed with a vibrant gradient of purple, pink, and yellow. The colors blend seamlessly, creating a stunning fade effect that shifts with every angle."
  },
  {
    id: 4,
    name: "USP-S | Orion",
    img: p5,
    price: 120,
    maxPrice: 180,
    color: "blue",
    rating: 5,
    rarity: "Covert",
    orderedBy: "Newest",
    currency: "USD",
    description: "A silver and black space-themed design with constellation patterns. The slide features a deep blue galaxy finish with glowing stars, inspired by the Orion nebula."
  },
  {
    id: 5,
    name: "P250 | See Ya Later",
    img: p1,
    price: 70,
    maxPrice: 125,
    color: "purple",
    rating: 3,
    rarity: "Restricted",
    orderedBy: "Popularity",
    currency: "USD",
    description: "A custom paint job featuring a green mechanical alligator with a menacing grin. The phrase 'See Ya Later' is scrawled across the slide in graffiti style."
  },
  {
    id: 6,
    name: "Five-SeveN | Hyper Beast",
    img: p6,
    price: 90,
    maxPrice: 140,
    color: "black",
    rating: 4,
    rarity: "Classified",
    orderedBy: "Rating",
    currency: "USD",
    description: "A vibrant, multicolored beast with sharp teeth and glowing eyes covers the entire weapon. The design pulses with neon energy, making it a true hyper beast on the battlefield."
  },
  {
    id: 7,
    name: "Tec-9 | Fuel Injector",
    img: p7,
    price: 110,
    maxPrice: 160,
    color: "yellow",
    rating: 5,
    rarity: "Covert",
    orderedBy: "Price",
    currency: "USD",
    description: "A high-octane yellow and black racing theme with exposed mechanical parts and glowing fuel lines. It looks like it was ripped straight from a modified street racer."
  },
  {
    id: 8,
    name: "Dual Berettas | Melon9",
    img: p8,
    price: 60,
    maxPrice: 120,
    color: "white",
    rating: 3,
    rarity: "Restricted",
    orderedBy: "Popularity",
    currency: "USD",
    description: "Both pistols are painted with a playful watermelon pattern. Green rind, pink flesh, and black seeds create a refreshing and ironic dual-wield combo."
  },
  {
    id: 9,
    name: "R8 Revolver | Llama Cannon",
    img: p9,
    price: 75,
    maxPrice: 130,
    color: "yellow",
    rating: 4,
    rarity: "Classified",
    orderedBy: "Newest",
    currency: "USD",
    description: "A cartoon llama wearing sunglasses and a bandana is painted across the barrel. The phrase 'Llama Cannon' is boldly displayed — perfect for players with a sense of humor."
  },
  {
    id: 10,
    name: "USP-S | Kill Confirmed",
    img: p10,
    price: 145,
    maxPrice: 200,
    color: "black",
    rating: 5,
    rarity: "Covert",
    orderedBy: "Price",
    currency: "USD",
    description: "A dark, blood-splattered design with a skull and crossbones. The words 'Kill Confirmed' are etched into the slide, leaving no doubt about its lethal intent."
  },
  {
    id: 11,
    name: "Glock-18 | Bullet Queen",
    img: p11,
    price: 88,
    maxPrice: 150,
    color: "green",
    rating: 4,
    rarity: "Classified",
    orderedBy: "Rating",
    currency: "USD",
    description: "A golden crown and bullet casing dress adorn a fierce female figure. She rules the battlefield with style, power, and unapologetic dominance."
  },
  {
    id: 12,
    name: "P2000 | Handgun",
    img: p12,
    price: 55,
    maxPrice: 110,
    color: "green",
    rating: 3,
    rarity: "Restricted",
    orderedBy: "Popularity",
    currency: "USD",
    description: "A minimalist green and black design with the word 'HANDGUN' stamped across the slide. Simple, clean, and straight to the point."
  },
  {
    id: 13,
    name: "Tec-9 | Avalanche",
    img: p13,
    price: 68,
    maxPrice: 125,
    color: "orange",
    rating: 4,
    rarity: "Restricted",
    orderedBy: "Newest",
    currency: "USD",
    description: "An icy blue and white avalanche pattern sweeps across the weapon. Snow-capped peaks and frozen debris give it a cold, unstoppable feel."
  },
  {
    id: 14,
    name: "CZ75-Auto | Xiangliu",
    img: p14,
    price: 92,
    maxPrice: 160,
    color: "orange",
    rating: 4,
    rarity: "Classified",
    orderedBy: "Price",
    currency: "USD",
    description: "A custom paint job with nine purple and gold snakes has been applied. Inspired by the mythical Xiangliu, it warns: Beware the rising tide."
  },
  {
    id: 15,
    name: "P250 | Muertos",
    img: p15,
    price: 63,
    maxPrice: 120,
    color: "red",
    rating: 3,
    rarity: "Restricted",
    orderedBy: "Popularity",
    currency: "USD",
    description: "A Day of the Dead-inspired design with sugar skulls, roses, and vibrant red patterns. Celebrates life and death in equal measure."
  },
  {
    id: 16,
    name: "Five-SeveN | Angry Mob",
    img: p16,
    price: 85,
    maxPrice: 140,
    color: "red",
    rating: 5,
    rarity: "Classified",
    orderedBy: "Rating",
    currency: "USD",
    description: "A chaotic scene of angry protesters with torches and pitchforks. The mob is coming — and they’re not here to negotiate."
  },
  {
    id: 17,
    name: "Dual Berettas | Co Strike",
    img: p17,
    price: 78,
    maxPrice: 130,
    color: "red",
    rating: 4,
    rarity: "Classified",
    orderedBy: "Newest",
    currency: "USD",
    description: "Twin cobras strike in unison across both pistols. Red scales and venomous eyes create a deadly symmetrical threat."
  },
  {
    id: 18,
    name: "R8 Revolver | Crazy 8",
    img: p18,
    price: 59,
    maxPrice: 110,
    color: "black",
    rating: 2,
    rarity: "Restricted",
    orderedBy: "Popularity",
    currency: "USD",
    description: "A graffiti-style '8' ball with dice, cards, and flames. For the gambler who plays Russian roulette with style."
  },
  {
    id: 19,
    name: "USP-S | Ticket to Hell",
    img: p19,
    price: 99,
    maxPrice: 160,
    color: "black",
    rating: 5,
    rarity: "Classified",
    orderedBy: "Price",
    currency: "USD",
    description: "A one-way ticket stamped in blood-red ink. Demons, flames, and a torn boarding pass lead straight to the underworld."
  },
  {
    id: 20,
    name: "Glock-18 | Water Elemental",
    img: p20,
    price: 115,
    maxPrice: 175,
    color: "green",
    rating: 5,
    rarity: "Covert",
    orderedBy: "Newest",
    currency: "USD",
    description: "A translucent blue water spirit flows across the slide. Waves, droplets, and glowing eyes give life to the elemental force within."
  },
  {
    id: 21,
    name: "P250 | Asiimov",
    img: p21,
    price: 102,
    maxPrice: 155,
    color: "red",
    rating: 4,
    rarity: "Classified",
    orderedBy: "Rating",
    currency: "USD",
    description: "A futuristic white, black, and orange geometric pattern. The iconic Asiimov design represents cutting-edge technology and precision."
  },
  {
    id: 22,
    name: "CZ75-Auto | Pole Position",
    img: p22,
    price: 66,
    maxPrice: 125,
    color: "blue",
    rating: 3,
    rarity: "Restricted",
    orderedBy: "Popularity",
    currency: "USD",
    description: "A racing-inspired livery with checkered flags, sponsor logos, and aerodynamic lines. Built for speed and first-place finishes."
  },
  {
    id: 23,
    name: "Tec-9 | Isaac",
    img: p23,
    price: 74,
    maxPrice: 130,
    color: "blue",
    rating: 4,
    rarity: "Classified",
    orderedBy: "Newest",
    currency: "USD",
    description: "A sci-fi design with circuit boards, glowing blue nodes, and holographic text. Inspired by advanced AI and digital evolution."
  },
  {
    id: 24,
    name: "Five-SeveN | Protocol",
    img: p24,
    price: 97,
    maxPrice: 160,
    color: "orange",
    rating: 5,
    rarity: "Covert",
    orderedBy: "Price",
    currency: "USD",
    description: "A high-tech military prototype with hazard stripes, warning labels, and classified markings. Access granted: Level 5 clearance required."
  }
];
const colors = ["red", "green", "blue", "yellow", "purple", "black", "white", "orange"];
const ratings = [5, 4, 3, 2, 1];

function Pistols({ isLoggedIn, setLoginModalOpen, handleLogout }) {
  const [priceRange, setPriceRange] = useState([50, 200]);
  const [selectedColors, setSelectedColors] = useState([]);
  const [selectedRating, setSelectedRating] = useState(null);
  const [openFilter, setOpenFilter] = useState("Price");
  const [selectedRarity, setSelectedRarity] = useState(null);
const [selectedOrderBy, setSelectedOrderBy] = useState(null);


  const navigate = useNavigate();

  // Filtering
  // const filteredPistols = pistolsData.filter((pistol) => {
  //   const inPrice = pistol.price >= priceRange[0] && pistol.price <= priceRange[1];
  //   const inColor = selectedColors.length === 0 || selectedColors.includes(pistol.color);
  //   const inRating = !selectedRating || pistol.rating === selectedRating;
  //   return inPrice && inColor && inRating;
  // });
  let filteredPistols = pistolsData.filter((pistol) => {
  const inPrice = pistol.price >= priceRange[0] && pistol.price <= priceRange[1];
  const inColor = selectedColors.length === 0 || selectedColors.includes(pistol.color);
  const inRating = !selectedRating || pistol.rating === selectedRating;
  const inRarity = !selectedRarity || selectedRarity === "Any" || pistol.rarity === selectedRarity;
  return inPrice && inColor && inRating && inRarity;
});

// Add sorting
if (selectedOrderBy) {
  filteredPistols = [...filteredPistols].sort((a, b) => {
    switch (selectedOrderBy) {
      case "Price":
        return a.price - b.price;
      case "Rating":
        return b.rating - a.rating;
      case "Popularity":
        return a.id - b.id;
      case "Newest":
        return b.id - a.id;
      default:
        return 0;
    }
  });
}

const handleRarityChange = (rarity) => {
  setSelectedRarity(rarity === selectedRarity ? null : rarity);
};

const handleOrderByChange = (orderBy) => {
  setSelectedOrderBy(orderBy === selectedOrderBy ? null : orderBy);
};


  // Handlers
  const handlePriceChange = (e, idx) => {
    const newRange = [...priceRange];
    newRange[idx] = Number(e.target.value);
    setPriceRange(newRange);
  };

  const handleColorChange = (color) => {
    setSelectedColors((prev) =>
      prev.includes(color) ? prev.filter((c) => c !== color) : [...prev, color]
    );
  };

  const handleRatingChange = (rating) => {
    setSelectedRating(rating === selectedRating ? null : rating);
  };

  const handleNavigate = (itemName) => {
    navigate(`/items/${encodeURIComponent(itemName)}`);
  };

  const toggleSection = (section) => {
    setOpenFilter(openFilter === section ? "" : section);
  };

  return (
    <div className="categories-page">
      <Header
        isLoggedIn={isLoggedIn}
        setLoginModalOpen={setLoginModalOpen}
        handleLogout={handleLogout}
      />
      <div className="categories-content">
        <Filter
          openFilter={openFilter}
          toggleSection={toggleSection}
          priceRange={priceRange}
          handlePriceChange={handlePriceChange}
          selectedColors={selectedColors}
          handleColorChange={handleColorChange}
          selectedRating={selectedRating}
          handleRatingChange={handleRatingChange}
          colors={colors}
          ratings={ratings}
            selectedRarity={selectedRarity}
  handleRarityChange={handleRarityChange}
  selectedOrderBy={selectedOrderBy}
  handleOrderByChange={handleOrderByChange}
        />
        <ItemGrid
          items={filteredPistols}
          categoryImage={p}
          categoryAlt="CZ75-Auto"
          categoryTitle="CZ75-Auto Skins"
          categoryDescription="Browse and buy all CZ75-Auto skins for CS2. A fully automatic variant of the CZ75, the CZ75-Auto is the ideal short-term choice for turning the tables and gaining your opponent's weapon. But with very little ammo in the magazine, strong trigger discipline is required."
          onItemClick={handleNavigate}
          isLoggedIn={isLoggedIn}                   
          setLoginModalOpen={setLoginModalOpen}
        />
      </div>
    </div>
  );
}

export default Pistols;